import * as Sentry from '@sentry/react';

export function resetObservability() {
  Sentry.setUser(null);
  Sentry.setTag('tenant', null);
  Sentry.setTag('tenant_id', null);
  Sentry.setContext('user_profile', null);
  Sentry.setContext('tenant_settings', null);
}
